import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { SetServiceStateData } from './types';

const initialState: SetServiceStateData = {
	data: {
		data: {
			message: '',
			error: '',
		},
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchSetService = createAsyncThunk(
	'api/fetchSetService',
	({ sessionId, uslugaId }: { sessionId: string; uslugaId: string }) => api.fetchSetService(sessionId, uslugaId),
);

const setServiceSlice = createSlice({
	name: 'setService',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchSetService.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchSetService.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchSetService.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default setServiceSlice.reducer;
